import { useState } from "react";
import { useListContext, useRecordContext } from "ra-core";
import { Link } from "react-router";
import { UserPlus } from "lucide-react";
import { ReferenceManyField } from "@/components/admin/reference-many-field";
import { Button } from "@/components/ui/button";
import { ContactCreateSheet } from "../../contacts/ContactCreateSheet";
import type { Contact } from "../../types";

/** PRD 1.9 en celular: contactos de la empresa y alta de uno nuevo. */
export const CompanyContactsMobile = () => {
  const company = useRecordContext();
  const [open, setOpen] = useState(false);
  if (!company) return null;
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold border-b pb-1 mb-2">Contactos</h3>
      <ReferenceManyField
        reference="contacts_summary"
        target="company_id"
        sort={{ field: "id", order: "ASC" }}
      >
        <ContactRows />
      </ReferenceManyField>
      <Button variant="outline" className="mt-2" onClick={() => setOpen(true)}>
        <UserPlus /> Agregar contacto
      </Button>
      <ContactCreateSheet
        open={open}
        onOpenChange={setOpen}
        companyId={company.id}
      />
    </div>
  );
};

const ContactRows = () => {
  const { data } = useListContext<Contact>();
  return (
    <ul className="flex flex-col gap-2">
      {data?.map((c) => (
        <li key={c.id}>
          <Link to={`/contacts/${c.id}/show`} className="font-medium">
            {c.first_name} {c.last_name}
          </Link>
          {c.title && (
            <span className="text-sm text-muted-foreground"> · {c.title}</span>
          )}
        </li>
      ))}
    </ul>
  );
};
